import {
    FREEZE_WIZARD,
    NEXT_STEP_REQUEST, RESET_WIZARD_CACHE, SET_CURRENT_STEP, SET_STEP_VALIDATION
} from "../../actions/types";

const initialState = {
    nextStepRequested: false,
    stepsValidation: {},
    freezeWizard: false,
    isStepValid: true,
    currentStep: 0
};

export default function (state = initialState, action) {
    switch (action.type) {
        case NEXT_STEP_REQUEST:
            return {
                ...state,
                nextStepRequested: action.payload
            };
        case FREEZE_WIZARD:
            return {
                ...state,
                freezeWizard: action.payload
            };

        case RESET_WIZARD_CACHE:
            return {
                ...state,
                nextStepRequested: null,
                freezeWizard:false,
                currentStep: 0
            };
        case SET_CURRENT_STEP:
            return{
                ...state,
                currentStep: action.payload
            }
        case SET_STEP_VALIDATION:
            const stepsValidation = {...state.stepsValidation, [action.name]: action.isValid};
            const isStepValid = Object.keys(stepsValidation).reduce((value, step) => { 
                return value && stepsValidation[step];
             } , true);
            return {
                ...state,
                stepsValidation: stepsValidation,
                isStepValid: isStepValid
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/StepsValidationReducer/WizardReducer.js